export default __webpack_public_path__ + "static/media/AngularJS-Shield.01fab40a.svg";